// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FontStyle.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Font Style component
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import localizer from 'share/localization/Izenda.Localizer';
import ButtonCheck from 'share/components/controls/Izenda.ButtonCheck';

export default class FontStyle extends Component {
  state = {
    fontStyle: this.props.value
  };

  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
    border: PropTypes.bool
  };

  static defaultProps = {
    value: {
      fontBold: false,
      fontItalic: false,
      fontUnderline: false
    },
    border: false
  };

  componentWillReceiveProps(nextProps: any) {
    this.setState({ fontStyle: nextProps.value });
  }

  handleClick = (e: any) => {
    var props = this.props;
    var fontStyle = this.state.fontStyle;
    fontStyle[e.target.value] = !fontStyle[e.target.value];

    this.setState({ fontStyle: fontStyle }, function() {
      props.onChange && props.onChange({ value: fontStyle });
    });
  };

  renderButton = (btnName: string) => {
    const { handleClick } = this;
    const CLASS_FONTS = {
      fontBold: {
        class: 'text-bold',
        icon: 'B',
        title: localizer.getText('FONT_STYLE_BOLD_TOOLTIP')
      },
      fontItalic: {
        class: 'text-italic',
        icon: 'I',
        title: localizer.getText('FONT_STYLE_ITALIC_TOOLTIP')
      },
      fontUnderline: {
        class: 'text-underline',
        icon: 'U',
        title: localizer.getText('FONT_STYLE_UNDERLINE_TOOLTIP')
      }
    };
    const fontStyle = this.state.fontStyle;
    const buttonClass = classnames(CLASS_FONTS[btnName].class, {
      'font-style-border': this.props.border
    });

    return (
      <ButtonCheck
        hasValue={!!fontStyle[btnName]}
        key={btnName}
        className={buttonClass}
        type="button"
        value={btnName}
        title={CLASS_FONTS[btnName].title}
        onClick={handleClick}
      >
        {CLASS_FONTS[btnName].icon}
      </ButtonCheck>
    );
  };

  render() {
    const className = classnames('btn-group font-style', this.props.className);

    return (
      <div className={className} aria-label={localizer.getText('FONT_STYLE_ARIA_LABEL')}>
        {this.renderButton('fontBold')}
        {this.renderButton('fontItalic')}
        {this.renderButton('fontUnderline')}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.FontStyle.jsx